import { observable } from "mobx";
import { Type } from "class-transformer";
import DateRangeRequest from "./dateRangeRequest";
import SystemComponentOutageState from "./systemComponentOutageState";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class GetSystemComponentOutagesRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  @Type(() => DateRangeRequest)
  validity?: DateRangeRequest;

  @observable
  @Type(() => DateRangeRequest)
  visibility?: DateRangeRequest;

  @observable
  systemComponentId?: string;

  @observable
  state?: SystemComponentOutageState;

  @observable
  includeDeleted?: boolean;
}
